import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { MatDialogModule } from '@angular/material/dialog';
import { MatIconModule } from '@angular/material/icon';
import { RouterModule } from '@angular/router';
import { FlexLayoutModule } from '@ngbracket/ngx-layout';

import { IcebreakersStoreModule } from '@libs/src/icebreakers-store/icebreakers-store.module';
import { ToastModule } from '@libs/src/toast/toast.module';
import { VisibleGroupsModule } from '@main-client/src/app/core/visible-groups.module';
import { EmailVerificationBannerModule } from '@main-client/src/app/email-verification-banner/email-verification-banner.module';
import { HubWindowModule } from '@main-client/src/app/hub-window/hub-window.module';
import { GroupMembershipPipeModule } from '@main-client/src/app/pipes/group-membership-pipe/group-membership-pipe.module';
import { ProfileCompletionWidgetViewModule } from '@main-client/src/app/profile-completion-widget-view/profile-completion-widget-view.module';
import { ProfileAboutModule } from '@main-client/src/app/profile/profile-about/profile-about.module';
import { ProfileActionModule } from '@main-client/src/app/profile/profile-action/profile-action.module';
import { ProfileBasicInfoModule } from '@main-client/src/app/profile/profile-basic-info/profile-basic-info.module';
import { ProfileGroupItemModule } from '@main-client/src/app/profile/profile-group-item/profile-group-item.module';
import { ProfileIcebreakersModule } from '@main-client/src/app/profile/profile-icebreakers/profile-icebreakers.module';
import { ProfileIntroModule } from '@main-client/src/app/profile/profile-intro/profile-intro.module';
import { ProfileLoaderModule } from '@main-client/src/app/profile/profile-loader/profile-loader.module';
import { ProfileMoreInfoModule } from '@main-client/src/app/profile/profile-more-info/profile-more-info.module';
import { ProfileOpportunitiesModule } from '@main-client/src/app/profile/profile-opportunities/profile-opportunities.module';
import { ProfileScoreCardModule } from '@main-client/src/app/profile/profile-score-card/profile-score-card.module';

import { OpportunityBackend } from '@libs/src/opportunity/opportunity.backend';
import { CanDeactivateProfileEditGuardService } from '@main-client/src/app/profile/can-deactivate-profile-edit-guard.service';

import { ProfileViewComponent } from '@main-client/src/app/profile/profile-view/profile-view.component';

@NgModule({
  imports: [
    CommonModule,
    FlexLayoutModule,
    MatDialogModule,
    MatIconModule,
    EmailVerificationBannerModule,
    IcebreakersStoreModule,
    ProfileAboutModule,
    ProfileActionModule,
    ProfileGroupItemModule,
    ProfileBasicInfoModule,
    ProfileIcebreakersModule,
    ProfileIntroModule,
    ProfileLoaderModule,
    ProfileMoreInfoModule,
    ProfileOpportunitiesModule,
    RouterModule,
    ToastModule,
    VisibleGroupsModule,
    GroupMembershipPipeModule,
    HubWindowModule,
    ProfileCompletionWidgetViewModule,
  ],
  declarations: [ProfileViewComponent],
  exports: [ProfileViewComponent],
  providers: [OpportunityBackend, CanDeactivateProfileEditGuardService],
})
export class ProfileViewModule {}
